import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, Cookie } from "lucide-react";
import { api } from "@/lib/api";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cxoora_cookie_consent");
    if (!accepted) setShow(true);
  }, []);

  const accept = async (granted) => {
    localStorage.setItem("cxoora_cookie_consent", granted ? "all" : "essential");
    setShow(false);
    try {
      await api.post("/public/consent", { consent_type: "cookie", granted });
    } catch (e) { /* ignore */ }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-50 cxo-card p-4 sm:p-5" data-testid="cookie-banner">
      <div className="flex gap-3">
        <div className="shrink-0 w-9 h-9 rounded-full bg-[#EAF0FF] text-[#2D6BFF] flex items-center justify-center">
          <Cookie size={18} />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-slate-900">Utilizziamo i cookie</p>
          <p className="mt-1 text-xs text-slate-600 leading-relaxed">
            Usiamo cookie tecnici essenziali e, previo consenso, cookie di analytics per migliorare il servizio. Puoi cambiare le preferenze in qualunque momento.
          </p>
          <div className="mt-3 flex gap-2">
            <Button size="sm" className="bg-[#2D6BFF] hover:bg-[#1F57F2] text-white h-8" onClick={() => accept(true)} data-testid="cookie-accept">Accetta tutti</Button>
            <Button size="sm" variant="outline" className="h-8" onClick={() => accept(false)} data-testid="cookie-essential">Solo essenziali</Button>
          </div>
        </div>
        <button onClick={() => setShow(false)} className="text-slate-400 hover:text-slate-600" aria-label="Chiudi"><X size={16} /></button>
      </div>
    </div>
  );
};

export default CookieBanner;
